export default __webpack_public_path__ + "static/media/G_D_btn__Redazione_Roll.1ba3f5d6.svg";